/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Ndamanagement_Globalnda_Description3Inputs */

const en_coinvestments_ndamanagement_globalnda_description3 = /** @type {(inputs: Coinvestments_Ndamanagement_Globalnda_Description3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Applies to all organisations unless overridden with an organisation-specific NDA.`)
};

/**
* | output |
* | --- |
* | "Applies to all organisations unless overridden with an organisation-specific NDA." |
*
* @param {Coinvestments_Ndamanagement_Globalnda_Description3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_ndamanagement_globalnda_description3 = /** @type {((inputs?: Coinvestments_Ndamanagement_Globalnda_Description3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Ndamanagement_Globalnda_Description3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_ndamanagement_globalnda_description3(inputs)
});
export { coinvestments_ndamanagement_globalnda_description3 as "coInvestments_ndaManagement_globalNda_description" }